import { FONTS } from './fonts';

// Maps a theme config key to the CSS custom property it should set on the embed.
export const THEME_CSS_PROPERTIES = {
  bg: '--brand-bg',
  fg: '--brand-fg',
  fontHeading: '--font-heading',
  fontBody: '--font-body',
  radiusSurface: '--radius-surface',
  radiusButton: '--radius-button',
  radiusOption: '--radius-option',
  radiusContainer: '--radius-container',
};

const CLIENT_THEMES = {
  'pulselive-dev': {
    bg: 'coral',
    fg: 'white',
    fontHeading: FONTS.oswald,
    fontBody: FONTS.inter,
    radiusSurface: '24px',
    radiusButton: '16px',
  },
  'pulselive-test': {
    bg: 'rebeccapurple',
    fg: 'white',
    radiusSurface: '16px',
    radiusButton: '8px',
  },
};

/**
 * Gets the theme config for a tenant.
 *
 * @param {string} tenant tenant subdomain
 * @returns {object|undefined} theme config, or undefined if the tenant has no theme
 */
export const getClientTheme = (tenant) => {
  return CLIENT_THEMES[tenant];
};
